<template>
  <div class="asset-management-con">
    <InfoContainer
      :infoTitle="InfoContainerConfig['infoTitle']"
      :contentConfig="InfoContainerConfig['infoContent']"
    > 
      <!-- <el-skeleton slot="basicInfo" :rows="6" animated  v-if="isLoading"/> -->
      <template slot="basicInfo">
        <!-- 转融通 -->
        <avue-form
          v-if="projectType == 1"
          ref="basicInfo"
          v-model="basicInfoData"
          :option="projectConfig['refinancingConfig']"
        >
          <template slot="files">
            <div class="upload-container">
              <WordUpload
                @showFileName="showFileNames"
                fileMenuName="项目管理相关文件"
                :plain="true"
                :id="virtualId"
              />
              <div class="">
                <template v-for="(item, index) in files">
                  <div class="file_wrapper" :key="index">
                    <a
                      class="file_button"
                      target="_blank"
                      :href="
                        isWord(item.fileUrl)
                          ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                            item.fileUrl
                          : item.fileUrl"
                      type="text"
                      size="small"
                    >
                      {{ item.fileName }}
                    </a>
                    <i
                      @click="downLoadFile(item.id)"
                      class="el-icon-download del_icon"
                    ></i>
                    <i
                      @click="delFile(item.id, index, 'file')"
                      class="el-icon-circle-close del_icon"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </avue-form>
        <!-- 委托贷款/信托 -->
        <avue-form
          v-if="projectType == 2 || projectType == 3"
          ref="basicInfo"
          v-model="basicInfoData"
          :option="projectConfig['loanInstitutionConfig']"
        >
          <template slot="repayLimit">
            <div class="limit-container">
              <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"              
                style="margin-bottom: 10px;"
                v-model="limitStartTime"
                type="date"
                placeholder="请选择还款开始日期">
              </el-date-picker>
              <template v-for="(item, index) in limitList">
                <div class="select-one" :key="index">
                  <!-- <el-date-picker
                    v-model="item['limitArray']"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker> -->
                  <div class="select-content">
                    <el-date-picker
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"                    
                      style="width:95% !important;margin-right: 10px;"
                      v-model="item['limitArray']"
                      type="date"
                      placeholder="请选择还款日期">
                    </el-date-picker>
                    <el-input
                      v-model="item['repayAmount']"
                      placeholder="请输入还款金额"
                    >
                      <template slot="append">万元</template>
                    </el-input>
                  </div>
                  <i v-if="index == 0" @click="addRange" class="el-icon-circle-plus-outline icon-right"></i>
                  <i v-if="index != 0" @click="reduceRange(item, index)" class="el-icon-remove-outline icon-right"></i>
                </div>
              </template>
            </div>
            <!-- <div v-else class="limit-container">
              <div class="select-one" :key="index">
                <el-date-picker
                  v-model="limitList[0]['limitArray']"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
                <i @click="addRange" class="el-icon-circle-plus-outline icon-right"></i>
              </div>              
            </div> -->
          </template>

          <template v-if="projectType == 2" slot="files">
            <div class="upload-container">
              <WordUpload
                @showFileName="showFileNames"
                fileMenuName="项目管理相关文件"
                :plain="true"
                :id="virtualId"
              />
              <div class="">
                <template v-for="(item, index) in files">
                  <div class="file_wrapper" :key="index">
                    <a
                      class="file_button"
                      target="_blank"
                      :href="
                        isWord(item.fileUrl)
                          ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                            item.fileUrl
                          : item.fileUrl"
                      type="text"
                      size="small"
                    >
                      {{ item.fileName }}
                    </a>
                    <i
                      @click="downLoadFile(item.id)"
                      class="el-icon-download del_icon"
                    ></i>
                    <i
                      @click="delFile(item.id, index, 'file')"
                      class="el-icon-circle-close del_icon"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
          </template>          
        </avue-form>
        <!-- 定增 -->
        <avue-form
          v-if="projectType == 4"
          ref="basicInfo"
          v-model="basicInfoData"
          :option="projectConfig['setTheGainConfig']"
        >
          <template slot="files">
            <div class="upload-container">
              <WordUpload
                @showFileName="showFileNames"
                fileMenuName="项目管理相关文件"
                :plain="true"
                :id="virtualId"
              />
              <div class="">
                <template v-for="(item, index) in files">
                  <div class="file_wrapper" :key="index">
                    <a
                      class="file_button"
                      target="_blank"
                      :href="
                        isWord(item.fileUrl)
                          ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                            item.fileUrl
                          : item.fileUrl"
                      type="text"
                      size="small"
                    >
                      {{ item.fileName }}
                    </a>
                    <i
                      @click="downLoadFile(item.id)"
                      class="el-icon-download del_icon"
                    ></i>
                    <i
                      @click="delFile(item.id, index, 'file')"
                      class="el-icon-circle-close del_icon"
                    ></i>
                  </div>
                </template>
              </div>
            </div>
          </template>        
        </avue-form>

        <div class="submit-con">
          <el-button type="primary" @click="validData">保存</el-button>
        </div>
      </template>
    </InfoContainer>
  </div>
</template>
<script>
import {tableConfig} from './config.js'
import InfoContainer from "@/components/infoContainer/infoContainer";
import {
  addProject,
  getDetail,
  queryInventedId
} from "@/api/zg/zg"
import WordUpload from "@/components/wordUpload/wordUpload"
import { downLoadTemplate } from "@/router/downLoadTem"
import * as dictionaries from "@/api/zd/dictionaries"
import { getUserInfo } from "@/api/system/user";
export default {
  name: 'assetManagement',
  data() {
    return {
      files: '',
      virtualId: '',
      isLoading: true,
      /**
       * 项目类型 1.转融通 2.委托贷款 3.信托 4.定增
       */
      isEdit: false,
      projectType: '',
      projectConfig: tableConfig(),
      basicInfoData: {},
      userInfo: {},
      limitStartTime: '',
      limitList: [{limitArray: '',repayAmount: ''}],
      InfoContainerConfig: {
        infoTitle: '项目信息',
        infoContent: [{
          title: '基础信息',
          prop: 'basicInfo'
        }]
      }
    }
  },
  components: {
    InfoContainer,
    WordUpload
  },
  watch: {
    '$route':{
      handler(newData, oldData){
        // 新增情况下
        if(newData['query']&&newData['query']['projectType']){
          this.$refs['basicInfo'].resetForm()
          this.projectType = newData['query']['projectType']
          this.setProjectType(newData['query']['projectType'])
          this.getUserId()
          this.showFileUplod()
        }
        // 编辑页
        if(newData['params']&&newData['params']['id']){
          this.queryProjectDetail()
        }

      }
    }
  },
  mounted() {
    // 判断新增页面还是编辑页面
    if(this.$route['params']['id']){
      this.queryProjectDetail()
      this.virtualId = this.$route['params']['id']
    } else {
      this.projectType = this.$route['query']['projectType']
      // 判断新增类型
      this.setProjectType(this.projectType)
      // 新增时经办人为当前帐号数据
      this.getUserId()
      // 2022/03/07 若新增为转融通，先生成该条数据帐号
      if(this.projectType != 3) this.buildId()
      this.showFileUplod()
    }
    // 若类型是委托贷款或者信托， 获取融资方出资方数据
  },
  methods: {
    showFileUplod() {
      // 若是信托 无附件上传
      // this.$nextTick(() => {
        let newColumn = JSON.parse(JSON.stringify(this.projectConfig.loanInstitutionConfig.column))
        if(this.projectType == 3){
          newColumn[9].display = false
        }else{
          newColumn[9].display = true
        }
        this.projectConfig.loanInstitutionConfig.column = newColumn
    },

    // 通过文件夹名称获取菜单
    getFileMenuByNames() {
      let self = this
      dictionaries.getFileMenuByName({ fileMenuName:'项目管理相关文件' }).then((res) => {
        let baFileMenuId = res.data.data.id
        let params = {
          fileOtherId: self.virtualId,
          baFileMenuId: baFileMenuId
        }
        dictionaries.findFileByOtherId(params).then(fileRes => {
          if(fileRes['data']['data']['length'] > 0){
            self.files = fileRes['data']['data']
            // self.data['fileName'] = fileRes['data']['data']
          }else{
            self.files = []
            // self.data['fileName'] = []
          }
        })
      })
      .catch((res) => {
        console.log(res);
      });
    },

    showFileNames(data) {
      this.files = data
    },

    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

       //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this.files.splice(index, 1)
          // this.formData['files'].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    buildId() {
      let self = this
      queryInventedId().then(res => {
        if(res['data']['code'] == 200){
          self.virtualId = res['data']['data']
        }
      })      
    },

    addRange() {
      this.limitList.push({limitArray: '',repayAmount: ''})
    },

    reduceRange(item, index) {
      let self = this
      this.$confirm("确定删除该条还款期限?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let newArray = []
        newArray = newArray.concat(JSON.parse(JSON.stringify(self.limitList)))
        newArray.splice(index, 1)
        self.limitList = newArray
      });
    },

    setProjectType(type) {
      this.isLoading = false
      let projectTypeStr = type == 1?'转融通':type == 2?'委托贷款':type == 3?'信托':'定增'
      this.$set(this.basicInfoData, 'projectTypeStr', projectTypeStr)
    },

    getUserId() {
      let self = this
      getUserInfo().then((res) => {
        const user = res.data.data;
        self.userInfo = user
        self.basicInfoData['userName'] = user['name']
      });
    },

    queryProjectDetail() {
      let self = this
      let id = this.$route['params']['id']
      let basicInfo = {}
      getDetail({
        id: id
      }).then(res => {
        self.isLoading = false
        if(res['data']['code'] == 200){
          let data = res['data']['data']
          self.projectType = data.projectType
          self.showFileUplod()
          // 设置当前页面类型
          self.setProjectType(self.projectType)
          // 设置项目名称
          self.basicInfoData['name'] = data['name']
          // 设置客户数据
          self.basicInfoData['custId'] = data['custId'].toString()
          self.basicInfoData['remarks'] = data['remarks']
          self.basicInfoData['userName'] = data['managerUserName']
          switch(Number(data['projectType'])){
            // 按照项目类型回显数据
            case 1:
              basicInfo = data['projectRefinancing']
              basicInfo['arr'] = Number(basicInfo['arr']*100).toFixed(4)
              basicInfo['lendingDayPrice'] = Number(basicInfo['lendingDayPrice']).toFixed(4)
              basicInfo['interest'] = Number(basicInfo['interest']).toFixed(4)
              basicInfo['compensation'] = Number(basicInfo['compensation']).toFixed(4)
              self.getFileMenuByNames()
              break;
            case 2:
            case 3:
              if(data['projectType'] == 2) self.getFileMenuByNames()
              basicInfo = Number(data['projectType']) == 2 ? data['projectEntrustLoans']:data['projectFinancialLoans']
              basicInfo['creditTime'] = [basicInfo['creditBeginDate'],basicInfo['createEndTime']]
              basicInfo['investorId'] = basicInfo['investorId'].toString()
              basicInfo['creditNum'] = Number(basicInfo['creditNum'])
              basicInfo['arr'] = Number(basicInfo['arr']*100).toFixed(4)
              // 处理还款期限
              self.limitStartTime = basicInfo['creditBeginDate']
              if(basicInfo['creditDateList'].length > 0){
                self.limitList = []
                basicInfo['creditDateList'].map((item, index) => {
                  self.limitList.push({
                    limitArray: item['creditEndDate'],
                    repayAmount: Number(item['repayAmount']).toFixed(4)
                  })
                })
              }
              break;
            case 4:
              self.getFileMenuByNames()
              basicInfo = data['projectAdditionalStock']
              break;
          }
          self.basicInfoData = Object.assign(self.basicInfoData, basicInfo)
        }
      })
    },

    validData() {
      let self = this
      this.$refs['basicInfo'].validate((valid, done) => {
        if(valid){
          done()
          self.submitForm()
        } else {
          self.$message({
            type: "error",
            message: "请填写完整表单信息"
          })
        }
      })
    },

    submitForm() {
      let self = this
      let params = {}
      let msg = '新增成功'
      // 处理还款期限
      let creditDateList = []
      let isComplete = true
      if((this.projectType == 2 || this.projectType == 3) && this.limitList[0]['limitArray'] != []){
        // params['creditDateList'] = []
        this.limitList.map((item, index) => {
          if(item['limitArray'] !== '' && item['repayAmount'] !== ''){
            creditDateList.push({
              creditEndDate: item['limitArray'],
              repayAmount: item['repayAmount']
            })
          }else{
            self.$message({
              type: "warning",
              message: '请补充完整还款明细数据'
            });
            isComplete = false
          }
        })
      }

      // let nowDate = new Date()
      // let nowYear = nowDate.getFullYear()
      // let nowMonth = Number(nowDate.getMonth()) +1 <10?`0${Number(nowDate.getMonth()) +1}`:Number(nowDate.getMonth())+1
      // let nowDay = nowDate.getDate()<10?`0${nowDate.getDate()}`:nowDate.getDate()
      // let initDate = `${nowYear}-${nowMonth}-${nowDay}`
      // 存入经办人数据
      // 根据类型存入数据
      switch(Number(this.projectType)){
        case 1:
          params = {
            projectRefinancing: this.basicInfoData
          }
          params['name'] = `${this.basicInfoData['lendingDate']} ${this.basicInfoData['securitiesInstitution']}${this.basicInfoData['securitiesObject']}`
          params['projectRefinancing']['arr'] = (Number(this.basicInfoData['arr'])/100).toFixed(4)
          break;
        case 2:
          params = {
            projectEntrustLoans : this.basicInfoData
          }
          params['projectEntrustLoans']['creditBeginDate'] = this.limitStartTime
          params['projectEntrustLoans']['investor'] = this.basicInfoData['$investorId']
          params['projectEntrustLoans']['arr'] = (Number(this.basicInfoData['arr'])/100).toFixed(4)
          params['projectEntrustLoans']['creditDateList'] = creditDateList
          break;
        case 3:
          params = {
            projectFinancialLoans: this.basicInfoData
          }
          params['projectFinancialLoans']['creditBeginDate'] = this.limitStartTime
          params['projectFinancialLoans']['investor'] = this.basicInfoData['$investorId']
          params['projectFinancialLoans']['arr'] = (Number(this.basicInfoData['arr'])/100).toFixed(4)          
          params['projectFinancialLoans']['creditDateList'] = creditDateList
          break;
        case 4:
          params = {
            projectAdditionalStock:this.basicInfoData
          }
          break;
      }
      // 存入客户数据
      params['custType'] = '3'
      params['custId'] = this.basicInfoData['custId']
      params['remarks'] = this.basicInfoData['remarks']
      params['name'] = this.projectType != 1?this.basicInfoData['name']:params['name']
      params['managerUser'] = this.userInfo['id']
      params['managerUserName'] = this.userInfo['realName']
      params['projectType'] = this.projectType
      if(this.$route['params']['id']){
        params['id'] = this.$route['params']['id']
        msg = '编辑成功'
      }else {
        params['id'] = this.virtualId
      }
      if(isComplete){
        addProject(params).then(res => {
          // console.info(res)
          if(res['data']['code'] == 200){
            self.$message({
              type: "success",
              message: msg
            });
            self.$router.go(-1)
            // ('/zg/projectmanage/projectList')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.asset-management-con{
  .file_wrapper {
    display: flex;
    align-items: center;
    min-height: 35px;
    .file_button {
      display: contents;
      color: #333333;
      font-weight: 400;
      &:hover {
        color: #409eff;
      }
    }
  }
  .submit-con{
    text-align: center;
    margin-bottom: 40px;
    button{
      width: 150px;
    }
  }
  .select-one{
    position: relative;
    width: 98%;
    margin-bottom: 10px;
    .select-content{
      display: flex;
      justify-content: space-between;
      align-items: center;
      // /deep/.el-input{
      //   width: 95% !important;
      // }
    }
    .icon-right{
      cursor: pointer;
      position: absolute;
      right: -25px;
      top: 8px;
      font-size: 15px;
    }
  }
}
</style>